<template>
    <div class="integralGiftConvertBox">
        <div class="giftContent">
            <div class="gigtScroll">
                <div class="swiperBox">
                    <md-swiper
                            ref="swiper"
                            :is-prevent="false"
                            :useNative-driver="false"
                            :transition-duration="1000"
                            :has-dots="false"
                            @after-change="afterChageFn"
                            :autoplay="0"
                    >
                        <md-swiper-item :key="$index" v-for="(item, $index) in giftList.picture">
                            <img  class="banner-item" :src="`/manager/fileserver/file/download?id=${item}`" />
                        </md-swiper-item>
                    </md-swiper>
                    <div class="dots">{{Idx}}/{{giftList.picture.length}}</div>
                </div>
                <div class="goodTest">
                    <div class="goodTestContent">
                        基本信息
                    </div>
                    <div class="goodTestItem">
                        <div class="goodTitle">礼品名称</div>
                        <div class="goodTestItemContent">{{giftList.giftName}}</div>
                    </div>
                    <div class="goodTestItem">
                        <div class="goodTitle">礼品价值</div>
                        <div class="goodTestItemContent">{{giftList.giftPrice}} RMB</div>
                    </div>
                    <div class="goodTestItem">
                        <div class="goodTitle">兑换积分</div>
                        <div class="goodTestItemContent">{{giftList.score}} 积分</div>
                    </div>
                    <!--<div class="goodTestItem">-->
                        <!--<div class="goodTitle">库存数量</div>-->
                        <!--<div class="goodTestItemContent">{{giftList.inventoryNum}}</div>-->
                    <!--</div>-->
                    <!--<div class="goodTestItem" v-if="giftList.checkNumtag == 1">-->
                        <!--<div class="goodTitle">兑换数量</div>-->
                        <!--<div class="goodTestItemContent">{{giftList.checkNum}}</div>-->
                    <!--</div>-->
                    <div class="goodTestItem">
                        <div class="goodTitle">活动日期</div>
                        <div class="goodTestItemContent">{{giftList.beginDate}} ~ {{giftList.endDate}}</div>
                    </div>
                    <div class="goodTestItem">
                        <div class="goodTitle">礼品描述</div>
                        <div class="goodTestItemContent">{{giftList.giftDesc}}</div>
                    </div>
                </div>


            </div>
            <div class="bottomBtn">
                <div class="homeBtn" @click="gotoHomeFn">
                    <i class="iconfont iconshouye1"></i>
                    <span>首页</span>
                </div>
                <div class="giftBtn" @click="zheZhaoStateFn">我要兑换</div>
            </div>
        </div>

        <div class="zheZhao" v-show="zheZhaoState">
            <div :class="['goodSelectBox', {'transitionGo':state},{'transitionGo2': !state}]" >
                <div class="imgBox">
                    <img src="http://i1.mallcoo.cn/sp_mall/6cd7396c-6e9d-4fa9-b63b-7c6f291d1b12_375x388_1_0_80.png" >
                </div>
                <i class="iconfont iconbuoumaotubiao20" @click="zheZhaoStateFn"></i>
                <div class="zheZhaoTestabel">
                    <div class="zJf">{{giftList.score}} 积分</div>
                    <!--<div class="zCc">库存 {{giftList.inventoryNum}} 件</div>-->
                    <div class="zName">{{giftList.giftName}}</div>
                </div>
                <div class="zContent">
                    <md-field>
                        <md-field-item title="兑换数量">
                            <!--giftList.checkNumtag==1?giftList.checkNum:giftList.inventoryNum-->
                            <md-stepper slot="right" min="0" v-model="giftNum" :max="99" />
                        </md-field-item>
                        <md-field-item title="手机号">
                            <div class="phonNum">{{userData.phone}}</div>
                        </md-field-item>
                        <md-input-item
                                title="验证码"
                                v-model="securityCode"
                                type="digit"
                                @blur="onBlur"
                        >
                            <div class="operatorNum" v-if="securityState" slot="right" >{{num}}s</div>
                            <div class="input-operator" @click="securityCodeFn" v-else slot="right" >获取验证码</div>
                        </md-input-item>
                    </md-field>
                </div>
                <div class="affirmBtn" @click="giftSubmit">确认兑换</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "integralGiftConvert",
        created(){
            this.giftList = JSON.parse(this.$route.query.itemData)
            // console.log(this.giftList)
            this.userData = JSON.parse(localStorage.getItem("userData"))

        },
        mounted() {
            document.title = "积分换礼"
        },
        data(){
          return {
              imgUrls: [
                  'http://pic1.win4000.com/wallpaper/c/53cdd1ec00d80.jpg',
                  'http://pic1.win4000.com/wallpaper/c/53cdd1efe22b8.jpg',
                  'http://pic1.win4000.com/wallpaper/c/53cdd1f41226b.jpg'
              ],
              Idx:1,
              zheZhaoState:false,//控制遮罩
              state:false,//控制过渡动画
              securityCode:'',//验证码
              securityState:false, //换取验证码按钮状态
              num:60,
              giftList:'', //商品数据
              userData:'', //用户数据
              giftNum:1, //兑换数量
              wei:6, //验证码位数
          }
        },
        methods:{
            onBlur(){
                document.body.scrollTop = 0;
            },
            afterChageFn(from, to){
                this.Idx = to+1
            },
            gotoHomeFn(){//跳转到home
                this.$router.push('/appMain/home')
            },
            zheZhaoStateFn(){
               if(this.giftList.checkNumtag == 1&&this.giftList.checkNum == 0){
                       this.UI.Toast.info('兑换次数已用完')
                       return
               }
               if(this.giftList.inventoryNum == 0){
                   this.UI.Toast.info('库存已完')
                   return
               }
                this.zheZhaoState = !this.zheZhaoState
                setTimeout(()=>{
                    this.state = !this.state
                },60)
            },
            securityCodeFn(){ //获取验证码
                let jf = this.userData.cardScore //会员积分
                let newJf = this.giftNum * this.giftList.score //兑换商品积分
                if(jf < newJf){
                    this.UI.Toast.failed("积分值不够，无法兑换")
                    return
                }

                this.securityState = true
                this.stop = setInterval(()=>{
                    if(this.num == 0){
                        clearInterval(this.stop)
                        this.securityState = false
                        this.num = 60
                    }else{
                        this.num--
                    }
                },1000)

                let mes = new URLSearchParams()
                mes.append('phone', this.userData.phone) //手机
                mes.append('id', this.userData.wxOpenId) //用户id
                mes.append('num', this.wei) //验证码位数
                this.$http.post('/system/base/securityCode/message', mes).then(({data})=>{ //获取验证码
                    // console.log(data)
                })
            },
            giftSubmit(){

                if(this.securityCode.length != this.wei){
                    this.UI.Toast.failed(`请输入正确的验证码（${this.wei}位）`)
                    return
                }
                let dt = new URLSearchParams()
                dt.append('memberId', this.userData.id)
                dt.append('giftNo', this.giftList.giftNo)
                dt.append('num', this.giftNum)
                dt.append('msgCode', this.securityCode)
                this.$http.post('/sangto-wrm/vip/scoreGift/exchange', dt).then(({data})=>{
                    if(data.code == 200 && data != null){
                        //兑换完成更新会员积分
                        let openid = this.userData.wxOpenId
                        let dt = new URLSearchParams()
                        dt.append('openid',openid)
                        this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                            if(data.code == 200 && data.data != null){

                                let dataStr = JSON.stringify(data.data)
                                localStorage.setItem("userData", dataStr)
                            }else{
                                this.UI.Toast.failed(data.message)
                            }
                        })
                        this.UI.Dialog.alert({
                            title:'提示',
                            content:'兑换成功,请到服务台领取礼品',
                            confirmText: '确定',
                            onConfirm: () =>{

                                this.$router.push({path:'/appMain/integralGift'})
                            }
                        })
                    }else{
                        this.UI.Toast.failed(data.message)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.integralGiftConvertBox{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    .giftContent{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0px;
    }
    .gigtScroll{
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 55px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .banner-item{
        width: 100%;
        height: 260px;
    }
    .swiperBox{
        width: 100%;
        height: 260px;
        overflow: hidden;
        position: relative;
    }
    .dots{
        position: absolute;
        right: 12px;
        bottom: 10px;
        width: 50px;
        height: 28px;
        background-color: rgba(0,0,0,0.3);
        z-index: 100;
        line-height: 29px;
        text-align: center;
        color: #fff;
        border-radius: 15px;
        opacity: 0.8;
    }
    .goodTest{
        width: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 55px;
    }

    .goodTestContent{
        width: 84%;
        margin-top: 22px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        font-weight: bolder;
    }
    .goodTestItem{
        margin-top: 5px;
        width: 84%;
        height: 20px;
        font-size: 14px;
        display: flex;
    }
    .goodTitle{
        width: 65px;
        color: #555;
        line-height: 20px;
    }
    .goodTestItemContent{
        color: #222;
        line-height: 20px;
        padding-left: 20px;
        flex: 1;
    }

    .bottomBtn{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 55px;
        background-color: #fff;
        box-shadow: 0 -1px 4px 0 rgba(0,0,0,0.1);
        display: flex;
    }
    .homeBtn{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #555;
        i{
            font-size: 18px;
        }
        span{
            font-size: 14px;
        }
    }
    .giftBtn{
        flex: 4;
        background-color: #cc3433;
        color: #fff;
        line-height: 55px;
        text-align: center;
        font-size: 16px;
        letter-spacing: 1px;
    }
    .zheZhao{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.4);
        .goodSelectBox{
            position: absolute;
            width: 100%;
            height: 365px;
            background-color: #fff;
            z-index: 500;
            bottom: 0;
            transition: transform 0.3s;
        }
        .imgBox{
            position: absolute;
            width: 110px;
            height: 100px;
            background-color: red;
            left: 20px;
            top: -30px;
            border-radius: 5px;
            overflow: hidden;
            border: 1px solid #f5f5f5;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .iconbuoumaotubiao20{
            position: absolute;
            font-size: 24px;
            top: 2px;
            right: 2px;
            padding: 8px;
            color: #555;
        }
        .transitionGo{
            transform: translateY(0px);
        }
        .transitionGo2{
            transform: translateY(410px);
        }
        .zheZhaoTestabel{
            width: 45%;
            position: absolute;
            top: 10px;
            left: 37%;
            font-size: 14px;
        }
        .zJf{
            color: #f40000;
        }
        .zCc{
            color: #777;
        }
        .zContent{
            width: 100%;
            position:absolute;
            top: 70px;
        }
        .operatorNum{
            margin-right: 11px;
            width: 60px;
            height: 34px;
            text-align: center;
            line-height: 34px;
            color: #ea5a59;
            border-radius: 4px;
            font-size: 14px;
        }
        .input-operator{
            margin-right: 1px;
            width: 100px;
            height: 34px;
            text-align: center;
            line-height: 34px;
            color: #26a2fc;
            border-radius: 4px;
            font-size: 14px;
        }
        .phonNum{
            position: relative;
            top: 3px;
            width: 95%;
            text-align: right;
            color: #888;
        }
        .affirmBtn {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 55px;
            background-color: #cc3433;
            color: #fff;
            font-size: 16px;
            text-align: center;
            line-height: 55px;
            letter-spacing: 1px;
        }
    }
}
</style>
